import React from 'react';
import { TableRow } from '@mui/material';
import { TableCellBody } from '../table/tableCell';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
interface TableRowItemProps {
    row: any;
    onEditClick: (row: any) => void;
    onDeleteClick: (userId: string, disabled: boolean) => void;
}

const formatDate = (dateString: string) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    }).format(date);
};


const TableRowItem: React.FC<TableRowItemProps> = ({ row, onEditClick, onDeleteClick }) => {
    return (
        <TableRow
            key={row.id}
            sx={{
                '&:last-child td, &:last-child th': { borderBottom: 0 },
            }}
        >
            <TableCellBody>{row.name}</TableCellBody>
            <TableCellBody>{row.category ? row.category : '-'}</TableCellBody>
            <TableCellBody>{row.type ? row.type : '-'}</TableCellBody>
            <TableCellBody>{formatDate(row.created_at)}</TableCellBody>
            <TableCellBody>{row.updated_at ? formatDate(row.updated_at): '-'}</TableCellBody>
            {/* <TableCellBody>
                <EditNoteOutlinedIcon
                    sx={{ cursor: 'pointer', marginRight: '5px' }}
                    onClick={() => onEditClick(row)}
                />
                
            </TableCellBody> */}
        </TableRow>
    );
};

export default TableRowItem;
